<template>
  <section class="container body">
    <h2>Gallery</h2>
    <div class="row">
        <gallery :images="images" :index="index" @close="index = null"></gallery>
        <div
        class="image"
        v-for="(image, imageIndex) in images"
        :key="imageIndex"
        @click="index = imageIndex"
        :style="{ backgroundImage: 'url(' + image + ')', width: '260px', height: '230px' }"
        ></div>
    </div>
  </section>
</template>
 
<script>
  import VueGallery from 'vue-gallery';
  
  export default {
    data: function () {
      return {
        publicPath: process.env.BASE_URL,
        images: [
          '/images/ScreensScreen_20359323.png',
          '/images/ScreensScreen_20359619.png',
          '/images/ScreensScreen_20359862.png',
          '/images/ScreensScreen_20360058.png',
          '/images/ScreensScreen_20360173.png',
          '/images/ScreensScreen_20359386.png',
          '/images/ScreensScreen_20359538.png',
          '/images/ScreensScreen_20359264.png',
        ],
        index: null
      };
    },
 
    components: {
      'gallery': VueGallery
    },
  }
</script> 
 
<style scoped>

    .row {
        display: flex;
        flex-wrap: wrap;
        padding: 0 4px;
    }

  .image {
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
    border: 1px solid #ebebeb;
    flex: 25%;
    max-width: 25%;
    padding: 0 4px;
  }

  section:after {
      clear: both;
  }

  .body {
      margin-top: 30px;
  }

    @media screen and (max-width: 800px) {
    .image {
        flex: 50%;
        max-width: 50%;
    }
    }

    /* Responsive layout - makes the two columns stack on top of each other instead of next to each other */
    @media screen and (max-width: 600px) {
        .image {
            flex: 100%;
            max-width: 100%;
        }
    }
</style> 
 